var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-3xl mx-auto lg:max-w-4xl",class:_vm.noPadding ? '' : 'px-4 sm:px-6 lg:px-8'},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }